(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9730],{

/***/ 55502:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'quote-left';
var width = 448;
var height = 512;
var aliases = [8220,"quote-left-alt"];
var unicode = 'f10d';
var svgPathData = 'M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.y1 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 77481:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mm_sem",
      function () {
        return __webpack_require__(41348);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ setContentWithFallbacks; }
/* harmony export */ });
/* unused harmony export SEMIndexPageTemplate */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(71292);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(2638);
/* harmony import */ var _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21611);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faCalendarCheck__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(52375);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faCarMechanic__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67170);
/* harmony import */ var _HowItWorksGreenCheckSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43906);
/* harmony import */ var _ReviewsV2Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18405);
/* harmony import */ var _getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10090);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61275);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22932);
/* harmony import */ var _ServicesHowItWorksSection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1948);
/* harmony import */ var _HappinessGuaranteeSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28763);
/* harmony import */ var _CallUsNowBar__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11667);
/* harmony import */ var _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42786);
/* harmony import */ var _HeaderSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79610);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faMoneyCheckEditAlt__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(38510);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_14__);























var SEMIndexPageTemplate = function(param) {
    var phoneNumber = param.phoneNumber, formalCity = param.formalCity, phoneNumberTxt = param.phoneNumberTxt, _type = param.type, type = _type === void 0 ? "generic" : _type, content = param.content, make = param.make, rating = param.rating, reviewCount = param.reviewCount;
    var headerTitle = (0,_getTitleFromUTMS__WEBPACK_IMPORTED_MODULE_15__/* .getTitleFromUTMS */ .u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        showFooter: false,
        showGetQuote: false,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        title: "Affordable Brake Repair Services".concat(formalCity ? " In ".concat(formalCity) : "", " | NuBrakes Mobile Brake Repair - We Come To You"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Need new brakes? Stay at home and let a certified NuBrakes brake tech come to you and repair your brakes for less than most".concat(formalCity ? " ".concat(formalCity) : "", " brake shops and dealerships on average.")
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeaderSection__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                rating: rating,
                formInitialProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, _Forms_ScheduleServiceMultiStep_NoEmailScheduleServiceFormMultiStep__WEBPACK_IMPORTED_MODULE_12__/* .twDefaultInitialWizardFormValues */ .oA), {
                    "form-name": "semScheduleServiceForm"
                }),
                reviewCount: reviewCount,
                title: headerTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HowItWorksGreenCheckSection__WEBPACK_IMPORTED_MODULE_5__/* .HowItWorksGreenCheckSection */ .x, {
                title: "Why NuBrakes?",
                first: {
                    title: "We Come To You",
                    subtitle: "Our mobile brake techs deliver top-rated brake repairs at your home or office for up to 40% less than a repair shop."
                },
                second: {
                    title: "Better Prices",
                    subtitle: "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money."
                },
                third: {
                    title: "Same-Day Availability",
                    subtitle: "Need your brakes repaired today? Same-day service is typically available — contact us to schedule!"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ServicesHowItWorksSection__WEBPACK_IMPORTED_MODULE_9__/* .ServicesHowItWorksSection */ .S, {
                phoneNumber: phoneNumber,
                title: "How NuBrakes Works",
                description: "Schedule top-rated brake services in minutes.",
                steps: [
                    {
                        title: "Get Your Free Repair Quote",
                        description: "Let us know what’s going on with your brakes and we’ll send you a free, no obligation repair quote for your vehicle.",
                        image: _fortawesome_pro_duotone_svg_icons_faMoneyCheckEditAlt__WEBPACK_IMPORTED_MODULE_18__/* .faMoneyCheckEditAlt */ .v4
                    },
                    {
                        title: "Select Your Repair Date",
                        description: "Availability as early as today. Choose a repair date and time that works around your schedule.",
                        image: _fortawesome_pro_duotone_svg_icons_faCalendarCheck__WEBPACK_IMPORTED_MODULE_19__/* .faCalendarCheck */ .Ry
                    },
                    {
                        title: "Enjoy Safer, Better Driving",
                        description: "Our brake technicians will ensure that your brakes are ready to hit the road and get you back to driving worry-free!",
                        image: _fortawesome_pro_duotone_svg_icons_faCarMechanic__WEBPACK_IMPORTED_MODULE_20__/* .faCarMechanic */ .cC
                    }, 
                ],
                buttonText: "Get A Quote"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ReviewsV2Section__WEBPACK_IMPORTED_MODULE_6__/* .ReviewsV2Section */ .r, {
                title: "Over 1000+ 5-Star Reviews",
                first: {
                    review: "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
                    from: "".concat(formalCity),
                    reviewer: "Tami F."
                },
                second: {
                    from: "".concat(formalCity),
                    reviewer: "Clinton B.",
                    review: "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
                },
                third: {
                    review: "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you’d pay at a pep boys or any other body shop. Can’t beat it.",
                    from: "".concat(formalCity),
                    reviewer: "William T."
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HappinessGuaranteeSection__WEBPACK_IMPORTED_MODULE_10__/* .HappinessGuaranteeSection */ .M, {
                title: "Happiness Guaranteed",
                description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Our brake techs have decades of combined experience, and all services are backed by our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_14___default()), {
                            href: "/warranty",
                            children: "NuBrakes Guarantee"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CallUsNowBar__WEBPACK_IMPORTED_MODULE_11__/* .CallUsNowBar */ .y, {
                phoneNumber: phoneNumber
            })
        ]
    });
};
function setContentWithFallbacks(type, content) {
    if (content !== "undefined") {
        return content;
    }
    switch(type){
        case "generic":
            return "";
        case "comp":
            return "brake shop";
        case "vehicle":
            return "";
        case "vehicle-part":
            return "brake-parts";
        case "mm_generic":
            return "auto-parts";
        case "mm_vehicle-part":
            return "auto-parts";
        default:
            return "";
    }
}
var SEMPage = function(param) {
    var _rating = param.rating, rating = _rating === void 0 ? "4.94" : _rating, _reviewCount = param.reviewCount, reviewCount = _reviewCount === void 0 ? 6013 : _reviewCount;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var query = router.query;
    var city = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "city", query);
    var type = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "type", query);
    var make = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "make", query);
    var content = (0,ramda__WEBPACK_IMPORTED_MODULE_7__/* .propOr */ .Uth)("", "utm_content", query);
    content = setContentWithFallbacks(type, content);
    var formalCity = city ? capital_case__WEBPACK_IMPORTED_MODULE_21__/* .capitalCase */ .I(city) : "";
    var phoneNumber = city && _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData */ .L[city] ? _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData */ .L[city].phoneNumber : _CityPhoneNumberData__WEBPACK_IMPORTED_MODULE_3__/* .CityPhoneNumberData["default"].phoneNumber */ .L["default"].phoneNumber;
    var phoneNumberTxt = (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_22__/* .formatPhoneNumber */ .u)(phoneNumber);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SEMIndexPageTemplate, {
        rating: rating,
        reviewCount: reviewCount,
        phoneNumberTxt: phoneNumberTxt,
        phoneNumber: phoneNumber,
        formalCity: formalCity,
        content: content,
        type: type,
        make: make
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (SEMPage);


/***/ }),

/***/ 90832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p_": function() { return /* reexport */ SegmentLogOnMount; },
  "XX": function() { return /* reexport */ Segment; }
});

// UNUSED EXPORTS: LogOnChange, SegmentProvider, useSegment

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/lib/segment/SegmentProvider.tsx



var SegmentContext = /*#__PURE__*/ react.createContext({
    eventProperties: {}
});
function useSegmentContext() {
    return react.useContext(SegmentContext);
}
function SegmentProvider(props) {
    var writeKey = props.writeKey;
    // Memoize so it's only really called if the params change
    var segmentClient = React.useMemo(function() {
        return AnalyticsBrowser.load({
            writeKey: writeKey
        });
    }, [
        writeKey
    ]);
    // We need to init such that LogOnMount is happy
    return /*#__PURE__*/ _jsx(SegmentContext.Provider, {
        value: {
            segmentClient: segmentClient,
            eventProperties: {}
        },
        children: props.children
    });
}

;// CONCATENATED MODULE: ./src/lib/segment/Segment.tsx
/* eslint-disable @typescript-eslint/no-unused-vars */ // import { DateTime } from 'luxon'



function Segment_useSegment() {
    var eventProperties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = useSegmentContext(), segmentClient = ref.segmentClient, inheritedProperties = ref.eventProperties;
    return react.useMemo(function() {
        var logEvent = function logEvent(eventType) {
            var eventPropertiesIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, callback = arguments.length > 2 ? arguments[2] : void 0;
            if (!segmentClient) {
                return;
            }
        // let computed = inheritedProperties
        // if (typeof eventProperties === 'function') {
        //   computed = eventProperties(computed)
        // } else {
        //   computed = { ...computed, ...(eventProperties || {}) }
        // }
        // if (typeof eventPropertiesIn === 'function') {
        //   computed = eventPropertiesIn(computed)
        // } else {
        //   computed = { ...computed, ...(eventPropertiesIn || {}) }
        // }
        // // event_time
        // computed = { ...computed, event_time: DateTime.now().toSeconds() }
        // segmentClient.track(eventType, computed, callback)
        };
        var instrument = // eslint-disable-next-line @typescript-eslint/ban-types
        function instrument(eventType, func) {
            function fn() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                var retVal = func ? func.apply(void 0, (0,_to_consumable_array/* default */.Z)(params)) : undefined;
                logEvent(eventType);
                return retVal;
            }
            return fn;
        };
        return {
            logEvent: logEvent,
            instrument: instrument,
            eventProperties: inheritedProperties,
            segmentClient: segmentClient
        };
    }, [
        eventProperties,
        inheritedProperties,
        segmentClient
    ]);
}
function Segment(props) {
    var ref = Segment_useSegment(undefined), logEvent = ref.logEvent, instrument = ref.instrument, eventProperties = ref.eventProperties;
    // If we're not providing any additional properties, just get out of the way and call the component
    if (!eventProperties) {
        return typeof props.children === "function" ? props.children({
            logEvent: logEvent,
            instrument: instrument
        }) : props.children || null;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // const value = React.useMemo(
    //   () => ({
    //     eventProperties: { ...eventProperties, ...(props.eventProperties || {}) },
    //     segmentClient,
    //   }),
    //   [eventProperties, props.eventProperties, segmentClient]
    // )
    return typeof props.children === "function" ? props.children({
        logEvent: logEvent,
        instrument: instrument
    }) : props.children || null;
// <SegmentContext.Provider value={value}>
//   {typeof props.children === 'function' ? props.children({ logEvent, instrument }) : props.children || null}
// </SegmentContext.Provider>
}

;// CONCATENATED MODULE: ./src/lib/segment/LogOnMount.tsx


var SegmentLogOnMount = function(param) {
    var eventType = param.eventType, children = param.children, eventProperties = param.eventProperties;
    var logEvent = Segment_useSegment().logEvent;
    react.useEffect(function() {
        logEvent(eventType, eventProperties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children || null;
};

;// CONCATENATED MODULE: ./src/lib/segment/LogOnChange.tsx


var SegmentLogOnChange = function(props) {
    var logEvent = useSegment().logEvent;
    React.useEffect(function() {
        logEvent(props.eventType, props.eventProperties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.value
    ]);
    return props.children || null;
};

;// CONCATENATED MODULE: ./src/lib/segment/index.tsx






/***/ }),

/***/ 41348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ mm_sem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SEMPage/sem-old/index.tsx
var sem_old = __webpack_require__(52929);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(71292);
// EXTERNAL MODULE: ./src/components/SEMPage/CityPhoneNumberData.tsx
var CityPhoneNumberData = __webpack_require__(21611);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/SEMPage/getTitleFromUTMS.tsx
var getTitleFromUTMS = __webpack_require__(10090);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/SEMPage/HeaderSection.tsx
var HeaderSection = __webpack_require__(79610);
// EXTERNAL MODULE: ./src/components/Forms/ScheduleServiceMultiStep/NoEmailScheduleServiceFormMultiStep.tsx + 2 modules
var NoEmailScheduleServiceFormMultiStep = __webpack_require__(42786);
// EXTERNAL MODULE: ./src/components/SEMPage/HowItWorksGreenCheckSection.tsx
var HowItWorksGreenCheckSection = __webpack_require__(43906);
// EXTERNAL MODULE: ./src/components/SEMPage/ServicesHowItWorksSection.tsx
var ServicesHowItWorksSection = __webpack_require__(1948);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/index.mjs
var pro_duotone_svg_icons = __webpack_require__(21702);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCalendarCheck.js
var faCalendarCheck = __webpack_require__(52375);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-duotone-svg-icons/faCarMechanic.js
var faCarMechanic = __webpack_require__(67170);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/img/nubrakes-van-house-small@3x.jpg
/* harmony default export */ var nubrakes_van_house_small_3x = ({"src":"/_next/static/media/nubrakes-van-house-small@3x.9f2b09ac.jpg","height":641,"width":1128,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDEQUGISIxYf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACMf/aAAwDAQACEQMRAD8AloyspkG48ulhAYS6Vj+ZHdDagL8KIinsBl2//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/SEMPage/ImageSection.tsx




var ImageSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "d-block d-md-none my-0 py-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: nubrakes_van_house_small_3x,
            alt: "NuBrakes Feature Image",
            layout: "responsive"
        })
    });
};
/* harmony default export */ var SEMPage_ImageSection = ((/* unused pure expression or super */ null && (ImageSection)));

// EXTERNAL MODULE: ./src/components/ReviewsV2Section.tsx
var ReviewsV2Section = __webpack_require__(18405);
// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
// EXTERNAL MODULE: ./src/components/CallUsNowBar.tsx
var CallUsNowBar = __webpack_require__(11667);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/segment/index.tsx + 4 modules
var segment = __webpack_require__(90832);
;// CONCATENATED MODULE: ./src/pages/mm_sem/index.tsx


























var MMSEMPageTemplate = function(param) {
    var phoneNumber = param.phoneNumber, formalCity = param.formalCity, phoneNumberTxt = param.phoneNumberTxt, _type = param.type, type = _type === void 0 ? "generic" : _type, content = param.content, make = param.make, rating = param.rating, reviewCount = param.reviewCount;
    var headerTitle = (0,getTitleFromUTMS/* getTitleFromUTMS */.u)({
        formalCity: formalCity,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        type: type,
        content: content,
        make: make,
        rating: rating,
        reviewCount: reviewCount
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        showFooter: false,
        showGetQuote: false,
        phoneNumber: phoneNumber,
        phoneNumberTxt: phoneNumberTxt,
        title: "Schedule Auto Repair In ".concat(formalCity, " | Auto Repair Services Starting At $99 | NuBrakes"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Schedule a top rated ".concat(formalCity, " Auto Repair Service in minutes from NuBrakes. NuBrakes is a mobile brake repair service based in Austin, TX. Our mobile brake technicians arrive on-site at your office, home or apartment fully equipped to handle your auto issues.")
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(segment/* Segment */.XX, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(segment/* LogOnMount */.p_, {
                        eventType: "Page Viewed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSection/* default */.Z, {
                        rating: rating,
                        formInitialProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, NoEmailScheduleServiceFormMultiStep/* twDefaultInitialWizardFormValues */.oA), {
                            "form-name": "semScheduleServiceForm"
                        }),
                        reviewCount: reviewCount,
                        title: headerTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksGreenCheckSection/* HowItWorksGreenCheckSection */.x, {
                        title: "Why NuBrakes?",
                        first: {
                            title: "We Come To You",
                            subtitle: "Our mobile mechanics deliver top-rated auto repairs at your home or office for up to 40% less than a repair shop."
                        },
                        second: {
                            title: "Better Prices",
                            subtitle: "We're 40% more affordable on average compared to the dealerships and shops so you'll be saving time and money."
                        },
                        third: {
                            title: "Same-Day Availability",
                            subtitle: "Need your vehicle repaired today? Same-day service is typically available — contact us to schedule!"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesHowItWorksSection/* ServicesHowItWorksSection */.S, {
                        phoneNumber: phoneNumber,
                        title: "How NuBrakes Works",
                        description: "Schedule top-rated auto repair services in minutes.",
                        steps: [
                            {
                                title: "Get Your Free Repair Quote",
                                description: "Let us know what’s going on with your vehicle and we’ll send you a free, no obligation repair quote.",
                                image: pro_duotone_svg_icons/* faMoneyCheckEditAlt */.v4z
                            },
                            {
                                title: "Select Your Repair Date",
                                description: "Availability as early as today. Choose a repair date and time that works around your schedule.",
                                image: faCalendarCheck/* faCalendarCheck */.Ry
                            },
                            {
                                title: "Enjoy Safer, Better Driving",
                                description: "Our mobile mechanics will ensure that your vehicle is ready to hit the road and get you back to driving worry-free!",
                                image: faCarMechanic/* faCarMechanic */.cC
                            }, 
                        ],
                        buttonText: "Get A Quote"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewsV2Section/* ReviewsV2Section */.r, {
                        title: "Over 1000+ 5-Star Reviews",
                        first: {
                            review: "We received fantastic, quick service, at a fair price. We got quite a few quotes and NuBrakes was the best price and it turns out, the quickest and best service. Our technician, Mike, was knowledgeable and friendly and got the job done quickly - all at my office. We would definitely recommend them and use the service again.",
                            from: "".concat(formalCity),
                            reviewer: "Tami F."
                        },
                        second: {
                            from: "".concat(formalCity),
                            reviewer: "Clinton B.",
                            review: "This service is awesome. You are paying for fast, convenient and good quality work. Communication with Walker was immediate and the technician Micheal was done in half the time that was quoted. I will use NuBrakes again in the future and recommend it to everyone. I mean, they come to you, that was what sold it for me."
                        },
                        third: {
                            review: "Without a doubt would recommend NuBrakes to anyone that needs brakes done. Service tech showed up on time and was professional and quick. And the conveniences having them come to you is hard to beat. Not to mention the price is close to half what you’d pay at a pep boys or any other body shop. Can’t beat it.",
                            from: "".concat(formalCity),
                            reviewer: "William T."
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                        title: "Happiness Guaranteed",
                        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Our mobile mechanics have decades of combined experience, and all services are backed by our",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/warranty",
                                    children: "NuBrakes Guarantee"
                                }),
                                "."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUsNowBar/* CallUsNowBar */.y, {
                        phoneNumber: phoneNumber,
                        title: "Schedule A Repair Or Get A Quote Now."
                    })
                ]
            })
        ]
    });
};
var MMSEMPage = function(param) {
    var rating = param.rating, reviewCount = param.reviewCount;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var city = (0,es/* propOr */.Uth)("", "city", query);
    var type = (0,es/* propOr */.Uth)("", "type", query);
    var make = (0,es/* propOr */.Uth)("", "make", query);
    var content = String(query.utm_content);
    content = (0,sem_old/* setContentWithFallbacks */.ZE)(type, content);
    var formalCity = dist_es2015/* capitalCase */.I(city ? city : "Austin");
    var phoneNumber = city ? CityPhoneNumberData/* CityPhoneNumberData */.L[city].phoneNumber : CityPhoneNumberData/* CityPhoneNumberData.default.phoneNumber */.L["default"].phoneNumber;
    if (city) {
        var phoneNumberTxt = (0,string_utils/* formatPhoneNumber */.u)(phoneNumber);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MMSEMPageTemplate, {
            rating: rating,
            reviewCount: reviewCount,
            phoneNumberTxt: phoneNumberTxt,
            phoneNumber: phoneNumber,
            formalCity: formalCity,
            content: content,
            type: type,
            make: make
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MMSEMPageTemplate, {
        rating: rating,
        reviewCount: reviewCount,
        formalCity: formalCity ? formalCity : "Austin",
        phoneNumber: phoneNumber ? phoneNumber : "5126402560",
        content: content,
        type: type,
        make: make,
        phoneNumberTxt: phoneNumber ? (0,string_utils/* formatPhoneNumber */.u)(phoneNumber) : "(512) 640-2560"
    });
};
var __N_SSG = true;
/* harmony default export */ var mm_sem = (MMSEMPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,2247,2978,4231,7858,4024,2932,6566,6263,7187,9774,2888,179], function() { return __webpack_exec__(77481); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);